<script>
import {
  computed, defineComponent, ref,
} from '@vue/composition-api';
import orderBy from 'lodash.orderby';
import { useCampaignsStats } from '../../composables/useCampaignStats';
import DashboardCampaignData from './DashboardCampaignData.vue';
import Loader from '../Loader.vue';
import { useManagerDashboard } from '../../composables/useManagerDashboard';

export default defineComponent({
  components: {
    DashboardCampaignData,
    Loader,
  },
  setup() {
    const { stats, loading } = useCampaignsStats();
    const { updatedAt, storeSelected } = useManagerDashboard();
    const filterBy = ref(['ACTIVE', 'COMPLETE']);
    const changeFilter = (filter) => {
      if (!filterBy.value.includes(filter)) {
        filterBy.value.push(filter);
      } else {
        filterBy.value = filterBy.value.filter((el) => el !== filter);
      }
    };
    const campaigns = computed(() => {
      if (!loading.value && stats.value && stats.value.length > 0) {
        const campaignsMapped = stats.value
          .filter((el) => {
            if (!el || el.length === 0) return false;
            const status = (filterBy.value ? filterBy.value.includes(el[0].status) : true);
            const stores = (storeSelected.value ? el.some((el2) => storeSelected.value.id.includes(el2.storeId)) : true);
            return (status && stores);
          })
          .map((stat) => {
            if (stat.length > 0) {
              const campaignStatsFilteredByStore = stat.filter((el) => storeSelected.value.id.includes(el.storeId));
              const campaignStats = campaignStatsFilteredByStore.reduce((a, b) => ({
                sent: a.sent + b.sent,
                total: a.total + b.total,
              }));
              return {
                id: stat[0].campaignId,
                storeId: stat[0].storeId,
                store: stat[0].store,
                name: stat[0].name,
                sent: campaignStats.sent,
                total: campaignStats.total,
                begin: stat[0].begin,
                end: stat[0].end,
                status: stat[0].status,
                sentPercentage: campaignStats.sent / campaignStats.total,
              };
            }
            return null;
          });
        return orderBy(campaignsMapped, ['status', (o) => Math.floor(o.sentPercentage * 100), 'end'], ['asc', 'asc', 'asc']);
      }
      return [];
    });

    return {
      filterBy,
      updatedAt,
      changeFilter,
      loading,
      stats,
      campaigns,
    };
  },
});
</script>

<template>
  <div>
    <div v-if="!loading">
      <div class="header">
        <h1 class="header__description">
          Estas são as suas campanhas do <strong>mês</strong>:
        </h1>
        <h3 class="header__date__update mt-2">
          Atualizado em: {{ updatedAt.date }} às {{ updatedAt.hours }}
        </h3>
      </div>
      <div class="status-chips-div">
        <v-btn
          :color="filterBy.includes('ACTIVE') ? 'primary' : '#F1EFEC'"
          class="status-chips text-capitalize"
          :style="filterBy.includes('ACTIVE') ? {'color': 'white'} : {'color': '#231F2080'}"
          large
          style="margin: 0"
          @click="changeFilter('ACTIVE')"
        >
          <v-icon class="chip-icon">
            mdi-bell-ring
          </v-icon>
          <div class="pl-1">
            Ativas
          </div>
        </v-btn>

        <v-btn
          :color="filterBy.includes('COMPLETE') ? 'primary' : '#F1EFEC'"
          class="status-chips text-capitalize ml-2"
          :style="filterBy.includes('COMPLETE') ? {'color': 'white'} : {'color': '#231F2080'}"
          large
          style="margin: 0"
          @click="changeFilter('COMPLETE')"
        >
          <v-icon class="chip-icon">
            mdi-check-circle
          </v-icon>
          <div class="pl-1">
            Completas
          </div>
        </v-btn>
      </div>
      <div v-if="campaigns.length > 0">
        <div
          v-for="campaign in campaigns"
          :key="campaign.id"
        >
          <DashboardCampaignData
            class="campaign-data"
            :campaign="campaign"
            :start-date="campaign.begin"
            :end-date="campaign.end"
            :sent-percentage="campaign.sentPercentage"
            :total-contacts="campaign.total"
            :contacts-sent="campaign.sent"
            :title="campaign.name"
            :status="campaign.status"
          />
        </div>
      </div>
      <div
        v-else
        class="text-xs-center mt-5"
      >
        Ops, não foi encontrada nenhuma campanha com esses filtros...
      </div>
    </div>
    <div v-else>
      <Loader />
    </div>
    <v-divider class="my-3" />
  </div>
</template>

<style lang="scss" scoped>
.header {
  &__description {
    font-family: 'Neue-Metana';
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    &__seller {
      font-weight: 600;
    }
  }
  &__date {
    margin-top: 2rem;
    &__update {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 14px;
    color: #959595;
    }
  }
}
.campaign-data {
  margin-top: 20px;
}
.status-chips-div {
  margin-top: 24px;
}
.status-chips {
  text-align: justify;
  padding-left: 25px !important;
  padding-right: 25px !important;
  width: 140.91px ;
  height: 33.56px;
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 14px;
  border-radius: 7px !important;
  text-transform: none;
}
.chip-icon {
  font-size: 14pt;
}
</style>
